
        require('./index.scss');
        'use strict';

var $adModel = require('model/service/advert.js');
var $mod = $('.module-loupan-recomd2');

var scroll = {
    init: function init() {
        var _ = window._;
        var $ = window.$;
        var temp = 0,
            hasNav = 0,
            scrollHeight,
            bodyHeight;
        var scrollFn = _.throttle(function () {
            var $youliks = $mod.find('[node-type="hot-loupan"]');
            var bdHeight = $mod.parents().find('#doc').find('#ft-block').height();
            var bdFootheight = 0;
            // 如果是楼盘相关页，需要加上loupan-nav的高度
            if (hasNav === 0 && $mod.parents().find('#doc').find('.page-nav-area.fix-top').size() > 0) {
                $youliks.addClass('has-nav');
                hasNav = 1;
            }
            // 获取页面的底部高度
            if ($mod.parents().find('#doc').find('#bd-foot').length > 0) {
                bdFootheight = $mod.parents().find('#doc').find('#bd-foot').height();
                bdHeight = bdFootheight + bdHeight;
            }
            scrollHeight = $mod.parent().offset().top + $mod.parent().height();
            $mod.parents().find('#doc').find('#bd').css({ 'position': 'relative', 'overflow': 'hidden' });
            bodyHeight = $mod.parents().find('#doc').height() - bdHeight - $youliks.height();
            var scrollTop = $(window).scrollTop();

            var scrollBodyHeight = hasNav === 0 ? bodyHeight : bodyHeight - 40;
            // console.log('scrollTop: ', scrollTop);
            if (scrollBodyHeight > scrollHeight) {
                if (scrollTop > scrollHeight && scrollTop < scrollBodyHeight) {
                    $youliks.removeClass('fix-bottom').css('bottom', '');
                    $youliks.addClass('fix-right');
                } else {
                    $youliks.removeClass('fix-bottom').css('bottom', '');
                    $youliks.removeClass('fix-right');
                    if (scrollTop >= scrollBodyHeight) {
                        $youliks.addClass('fix-bottom').css('bottom', bdFootheight + 'px');
                    }
                }
            }
        }, 100);
        $(window).on('scroll', scrollFn);
    }
};
var _module = {
    init: function init() {
        this.adInfo();
        scroll.init();
    },
    adInfo: function adInfo() {
        var cityId = parseInt($mod.data('cityid'), 10);
        var posId = 100076;
        var hasAd = $mod.data('hasad');
        var notFix = $mod.find('[node-type="you-likes"]').data('not_fix');
        if (hasAd === 1) {
            if (!cityId || !posId) {
                return;
            }
            $adModel.getAdData(cityId, posId, function (res) {
                // console.log('res: ', res);
                if (res.code == 200 && res.data.ad_map[posId]) {
                    var adDom = $mod.find('[node-type="ad"]');
                    var curData = res.data.ad_map[posId];
                    adDom.attr({
                        'href': curData.link,
                        'title': curData.description || ''
                    });
                    adDom.html('<img class="forum-ad-img" alt="' + (curData.description || '') + '" src="' + curData.resource_map.pic.url + '"><div class="ad_mark"></div>');
                    adDom.css('display', 'block');
                }
            });
        }
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/loupan-common/recomd-new/index.js